<template>
  <div>
    <Echarts
      :key="chartId"
      :containerId="chartId"
      :options="options"
      :data="data"
      :events="events"
      :refreshToken="chartId"
      :type="type"
    >
    </Echarts>
     <v-row no-gutters>
      <v-col class="ml-12">
        <v-checkbox class="opensansregularcase size8" v-model="selected" label="Show only regions/cities in the same country" value="1" @change="onlyCountryTU()"></v-checkbox>
      </v-col>
    </v-row>
</div>
</template>

<script>
  // eslint-disable-next-line
  import Echarts from '@/components/Echarts'
  // eslint-disable-next-line
  // import echarts from 'echarts'
  import { formatNumber } from '../utils/misc'

 
  export default {
    name: 'GraphBar',
  
    components: {
      Echarts
    },
 props: {
    type: String,
 },
  data () {
    let chartId = 'Graph-' + Math.random().toString(36).substring(2, 15)
    let options = []
    let data = {}
    let events = {"click": this.clickBar, "mouseover": this.mouseOver}
    return {
      chartId,
      options,
      data,
      events,
      selected: '',
      destroyed: false
    }
  },
  methods: {
    mouseOver: function (mo) {
      console.log(mo)
    },
    clickB: function (cb) {
      alert(cb)
      console.log(cb)
    },
    onlyCountryTU: function () {
      let name = this.$route.name
      let params = this.$route.params
      let query = this.$route.query
      if (this.selected != 1) {
        params.ctu = 'x'
      }
      else{
        params.ctu = '1'
      }
      this.$router.replace({  name: name, params: params, query: query })
      //this.prepareData()
      //this.loadGraph()
    },
    prepareData: function () {
      let params = this.$route.params
      let tl = params.tl
      let tlToWalk = {}
      if (tl === "TL2") {
        tlToWalk = this.$store.getters.TL2
      }
      else if (tl === "TL3") {
        tlToWalk = this.$store.getters.TL3
      }
      else if (tl === "FUA") {
        tlToWalk = this.$store.getters.FUA
      }
      else if (tl === "EFUA") {
        tlToWalk = this.$store.getters.EFUA
      }
      else if (tl === "CY") {
        tlToWalk = this.$store.getters.CY
      }
      let country_id = this.$store.getters.countryID
      let ds = this.$store.getters.ds
      let year = this.$store.getters.year.toString()

      
      this.data = []
      let ds_data = null
      let code = ''
      let value = ''

        for (let t of tlToWalk) {
          if (tl === "FUA" || tl === "EFUA" || tl === "CY") {code = t.id.toString()} else {code = t.code.toString()}
          if (this.selected != 1 || t.country == country_id ){
            if (tl === "FUA") {
              // ds_data = ds.Data({METRO_ID: code, TIME_PERIOD: year})
              value = ds.dataset[year][code]
            }
            else if(tl === "EFUA" || tl === 'TL2' || tl === 'TL3' || tl === 'FUA' || tl === 'CY'){
              value = ds.dataset[year][code]
            }
            else {
              ds_data = ds.Data({REG_ID: code, TIME: year})
            }
            if (ds_data) {
              value = ds_data.value
            }
            if (value){
              this.data.push([code, value])
            }
          }
        }

      this.data.sort(function(a, b) {
          return a[1] - b[1];
      })  
    },
  refresh: function () {
    if (!this.destroyed) {
      this.$store.commit('setshow_overlay', true)
      this.prepareData()
      this.loadGraph()
      this.$store.commit('setshow_overlay', false)
      this.$root.$once('component_refresh', () => {this.refresh()})
/*
      var myChart = echarts.init(document.getElementById(this.chartId))
      myChart.on('click', function (params) {
        console.log(params)
      })
*/
    }
  },
  loadGraph: function () {
    let params = this.$route.params

    var datax = []
    var datay = []
    var tu = this.$store.getters.TU
    var len = this.$store.getters.legendThresholds.length
    var color= ''
    var borderWidth=''
    var borderColor=''
    let index_tu
    let find = false

    for (index_tu in this.data) {
      if (this.data[index_tu][0] === tu) {
        find = true
        break
      }
    }
    var s = 0
    var e = 20
    if (find) {
      s = index_tu-1-10
      e = s+20
      }

    console.log(this.$store.getters.legendThresholds)
    console.log(this.$store.getters.legendColors)

    for (var n in this.data) {
      //if (this.data[n][0] === tu) {
      let value = this.data[n][1]
      borderWidth=0
      borderColor=''
      if (n === index_tu) {
        borderWidth=3
        borderColor='yellow'
      }

      color = 'rgb(220,220,220)'
      for (var t = 0; t < len-1 ; t++){ {
        if (value >= this.$store.getters.legendThresholds[t] && value < this.$store.getters.legendThresholds[t+1]) {
          color = this.$store.getters.legendColors[t]
                break
        }
      }


      //else {
        /*
        for (var t = len -1; t > 0; t--){
          color = 'rgb(220,220,220)'
          if (find) {
            if (this.$store.getters.legendThresholds[t]){
              if (value > this.$store.getters.legendThresholds[t]) {
                color = this.$store.getters.legendColors[t]
                break
              }
            }
          }
          */
      //}
      }
    
      var x = {
              value: value,
              nuts_id: this.data[n][0],
              itemStyle: { normal: { color: color, borderWidth: borderWidth, borderColor: borderColor } },
          }

      datax.push(x)

      let tu_name = ''
      tu_name = this.data[n][0]

      let tu_obj = this.$store.getters.allTUByCode[tu_name]

      if (tu_obj){
        tu_name = tu_obj.name

        if (tu_name.length > 20){ 
          tu_name = tu_name.substring(0, 20) + '...'
        }

        if (params.ctu == 'x') {
          tu_name = tu_name + '-' + tu_obj.country
        }
      }
      // console.log(datax)
      datay.push(tu_name )
    }

      let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },

        grid: {
          top:    0,
          bottom: 0,
          left: '0%',
          right: '0%',
          width: '80%',
          heigth: '100%',
          containLabel: true
        },

        dataZoom: [
        {
            show: true,
            yAxisIndex: 0,
            startValue: s,
            endValue: e,
        },
        {
            type: 'inside',
            yAxisIndex: 0,
        }],

        xAxis: {
            type: 'value',
            axisLabel: {
                formatter: (function(value){
                  let label;
                  if (value >= 1000000){ 
                    label = value / 1000000 + ' M'
                  }
                  else {
                    label = value
                  }
                  return label;
                 }),
                },
        },
        yAxis: 
           [{
            type: 'category',
            data: datay,
          }],
        series: 
         [
            {
            type: 'bar',
            label: {
                normal: {
                    position: 'right',
                    show: true,
                    formatter: function (params) {
                        return formatNumber(params.value);
                    }
                }
            },
            data: datax
            },
        ] 
    }
    this.options = option
   }
   },
    beforeDestroy () { 
      this.destroyed = true
      delete this.chartId
      delete this.options
      delete this.data
      delete this.selected
      //this.$root.$off('component_refresh_bar', () => {this.refresh()})
      console.log('*** DESTROYED GRAPH BAR ****')
    },
    mounted () {
      // this.$root.$on('change_graph_component_data', () => {
      console.log('*** MOUNTED GRAPH BAR ****')
      this.$root.$once('component_refresh', () => {this.refresh()})
      let params = this.$route.params
      this.selected = params.ctu
      this.prepareData()
      this.loadGraph()

/*      var myChart = echarts.init(document.getElementById(this.chartId))
      myChart.on('click', function (params) {
        console.log(params)
      })
*/
    }
  }
</script>


